var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "OrderCancellation" }, [
        _c("div", { staticClass: "header" }),
        _c("div", { staticClass: "whiteBg" }, [
          _c("div", { staticClass: "input" }, [
            _c(
              "div",
              { staticClass: "code-input" },
              [
                _c("el-input", {
                  staticClass: "custom-input",
                  attrs: {
                    size: "medium",
                    placeholder: "输入核销码或右侧扫码",
                    maxlength: "10",
                  },
                  model: {
                    value: _vm.verify_code,
                    callback: function ($$v) {
                      _vm.verify_code =
                        typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "verify_code",
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "scanner-button",
                    on: { click: _vm.openScanner },
                  },
                  [
                    _c("i", { staticClass: "el-icon-full-screen" }),
                    _c("i", { staticClass: "el-icon-minus" }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm.scannerVisible
            ? _c(
                "div",
                { staticClass: "scanner-section" },
                [
                  _c("QrcodeScanner", {
                    attrs: { "auto-start": true, "rear-camera": true },
                    on: { success: _vm.handleScanSuccess },
                    model: {
                      value: _vm.scannerVisible,
                      callback: function ($$v) {
                        _vm.scannerVisible = $$v
                      },
                      expression: "scannerVisible",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "image-section" },
            [
              _c("div", { staticClass: "section-header" }, [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v(" 图片凭证 "),
                ]),
                _c("div", { staticClass: "image-count" }, [
                  _vm._v(" " + _vm._s(_vm.images.length) + "/5 "),
                ]),
              ]),
              _c("ImagePicker", {
                attrs: {
                  "max-count": 5,
                  "min-count": 1,
                  "max-width": 2000,
                  quality: 0.8,
                },
                on: { "images-change": _vm.handleImagesChange },
                model: {
                  value: _vm.images,
                  callback: function ($$v) {
                    _vm.images = $$v
                  },
                  expression: "images",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "confirm-button",
              on: { click: _vm.storeCancellation },
            },
            [_vm._v("立即核销")]
          ),
        ]),
      ]),
      _vm.orderInfo && _vm.images.length
        ? _c("WriteOff", {
            attrs: { iShidden: _vm.iShidden, orderInfo: _vm.orderInfo },
            on: { cancel: _vm.cancel, confirm: _vm.confirm },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }